export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AppGetPosts.vue?vue&type=template&id=5ab93042&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/AppGetPosts.vue?vue&type=template&id=5ab93042&scoped=true&
// module id = 81
// module chunks = 0